import API, { buildBackendUrl } from '../config/API';

const config = (token) => ({ headers: { Authorization: token, 'Content-Type': 'application/json' } });

export const normalizeCourse = (course = {}) => ({
    ...course,
    id: course.course_id || course.id,
    course_id: course.course_id || course.id,
    image: buildBackendUrl(course.image || course.img_path || course.img),
    progress: Number(course.delivery_progress ?? course.progress ?? 0),
});

export async function fetchCourses(user, limit = 50) {
    if (!user?.token) return [];
    const endpoint = user.user_type === 1 ? 'teacher/courses' : 'cousres/enrolled';
    const response = await API.get(`${endpoint}?page=1&limit=${limit}`, config(user.token));
    return (response.data?.data || []).map(normalizeCourse);
}

export const normalizeEvents = (items = []) => items.flatMap((item) => {
    if (item.event_type === 'assignment' && item.assignment) {
        return [{
            ...item.assignment,
            event_type: 'assignment',
            title: item.assignment.title,
            date: item.date,
            course_id: item.course_id,
            course_title: item.course_title,
        }];
    }
    if (!Array.isArray(item.session)) return [];
    return item.session.map((session) => ({
        ...session,
        event_type: item.event_type || (session.is_meeting ? 'meeting' : 'session'),
        session_id: session.id,
        title: session.title,
        date: item.date,
        start_time: item.start,
        end_time: item.end,
        course_id: item.course_id || session.course_id,
        course_title: item.course_title,
    }));
});

export async function fetchEvents(user, limit = 100) {
    if (!user?.token) return [];
    const response = await API.get(`events?page=1&limit=${limit}`, config(user.token));
    return normalizeEvents(response.data?.data || []);
}
